import { useEffect, useState } from "react";

function CertificateCard({ label, image, explore, brochure, featurs }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    console.log("visible-hit", visible);
  }, [visible]);

  return (
    <div className="d-flex flex-column flex-column-reverse flex-md-row card-wrapper">
      <div className="col-12 col-md-5 mt-4 mt-md-0">
        <div className="d-flex text-left flex-column features pr-md-2">
          {featurs?.map((item) => (
            <div className="my-1 d-flex align-items-start">
              <picture className="mr-2 mr-md-4">
                <img src={item.img} alt={item.title} />
              </picture>
              <div>
                <h4 className="mb-2">{item.title}</h4>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="d-flex">
          <a
            className="btn d-flex justify-content-center align-items-center w-100 mr-2" target="_default"
            href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-09"
          >
            Explore Program
          </a>
          <a
            className="btn d-flex justify-content-center align-items-center w-100 filled-light" target="_default"
            href="https://drive.google.com/file/d/1W_wPuu7vn3RQB-XdtIPCdLGeKPybRElI/view"
          >
            Download Brochure
          </a>
        </div>
      </div>
      <div className="col-12 col-md-7 d-flex flex-column justify-content-end align-items-end justify-content-md-start img-section">
        <picture>
          <img
            className="img-fluid"
            src={image}
            alt={label}
            width={570}
            height={400}
          />
        </picture>
        <div
          className="click-btn d-flex justify-content-center align-items-center"
          onClick={() => setVisible(true)}
        >
          <picture>
            <svg
              viewBox="0 0 19 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.3077 9.69247H6.6923C6.31384 9.69247 6 9.37863 6 9.00017C6 8.62171 6.31384 8.30786 6.6923 8.30786H11.3077C11.6861 8.30786 12 8.62171 12 9.00017C12 9.37863 11.6861 9.69247 11.3077 9.69247Z"
                fill="#6C6C6C"
              ></path>
              <path
                d="M9.00004 12C8.62158 12 8.30774 11.6861 8.30774 11.3077V6.6923C8.30774 6.31384 8.62158 6 9.00004 6C9.3785 6 9.69235 6.31384 9.69235 6.6923V11.3077C9.69235 11.6861 9.3785 12 9.00004 12Z"
                fill="#6C6C6C"
              ></path>
              <path
                d="M9.10415 17.2187C4.63123 17.2187 0.989563 13.577 0.989563 9.10409C0.989563 4.63117 4.63123 0.989502 9.10415 0.989502C13.5771 0.989502 17.2187 4.63117 17.2187 9.10409C17.2187 13.577 13.5771 17.2187 9.10415 17.2187ZM9.10415 2.177C5.2804 2.177 2.17706 5.28825 2.17706 9.10409C2.17706 12.9199 5.2804 16.0312 9.10415 16.0312C12.9279 16.0312 16.0312 12.9199 16.0312 9.10409C16.0312 5.28825 12.9279 2.177 9.10415 2.177Z"
                fill="#6C6C6C"
              ></path>
              <path
                d="M17.4167 18.0103C17.2663 18.0103 17.1158 17.9549 16.9971 17.8361L15.4138 16.2528C15.1842 16.0232 15.1842 15.6432 15.4138 15.4136C15.6433 15.1841 16.0233 15.1841 16.2529 15.4136L17.8363 16.997C18.0658 17.2266 18.0658 17.6066 17.8363 17.8361C17.7175 17.9549 17.5671 18.0103 17.4167 18.0103Z"
                fill="#6C6C6C"
              ></path>
            </svg>
          </picture>
          <p>Click to zoom</p>

          <div
            className={`video-youtube-popup certificate-companies ${
              visible && "show"
            }`}
          >
            <div className="wrapper" onClick={() => setVisible(false)}>
              <div className="close-btn" onClick={() => setVisible(false)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 18 18 6M6 6l12 12"
                  />
                </svg>
                -{`${visible}`}
              </div>
              <picture  onClick={() => console.log('click on picture')}>
                <img className="img-fluid" src={image} alt={label} />
              </picture>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default CertificateCard;
